import CheckoutWorker from './checkout.worker.js?worker&inline';

function directFetch(payload) {
  return fetch(payload.url, {
    method: payload.method || 'POST',
    headers: payload.headers || {},
    body: payload.body === undefined ? null : payload.body,
    credentials: 'same-origin',
  }).then((response) => response.text().then((text) => {
    if (!response.ok) {
      const error = new Error('http_' + response.status);
      error.status = response.status;
      error.text = text;
      throw error;
    }

    let json = null;
    if (text) {
      try {
        json = JSON.parse(text);
      } catch (parseError) {
        const error = new Error('parse_error');
        error.text = text;
        throw error;
      }
    }

    return { json, text, status: response.status };
  }));
}

export class WorkerClient {
  constructor() {
    this.pending = new Map();
    this.sequence = 0;
    this.worker = null;

    this.spawn();
  }

  spawn() {
    try {
      this.worker = new CheckoutWorker();
      this.worker.addEventListener('message', (event) => this.onMessage(event));
      this.worker.addEventListener('error', () => this.onWorkerFailure());
      this.worker.addEventListener('messageerror', () => this.onWorkerFailure());
    } catch (error) {
      this.worker = null;
    }
  }

  request(payload) {
    if (!this.worker) {
      return directFetch(payload);
    }

    const id = ++this.sequence;

    return new Promise((resolve, reject) => {
      this.pending.set(id, { resolve, reject, payload });
      this.worker.postMessage({ type: 'request', id, ...payload });
    });
  }

  onMessage(event) {
    const message = event.data;

    if (!message || message.type !== 'response') {
      return;
    }

    const entry = this.pending.get(message.id);
    if (!entry) {
      return;
    }

    this.pending.delete(message.id);

    if (message.networkError || message.parseError || !message.ok) {
      entry.reject(toError(message));
      return;
    }

    entry.resolve({ json: message.json, text: message.text, status: message.status });
  }

  onWorkerFailure() {
    const pending = Array.from(this.pending.values());
    this.pending.clear();
    this.worker = null;

    pending.forEach((entry) => {
      directFetch(entry.payload).then(entry.resolve, entry.reject);
    });
  }
}

function toError(message) {
  const reason = message.networkError || (message.parseError ? 'parse_error' : 'http_' + message.status);
  const error = new Error(reason);
  error.status = message.status;
  error.text = message.text;

  return error;
}
